module.exports = __webpack_public_path__ + "img/money.afb8de5e.svg";